import {connect} from "react-redux";
import V2ActivityView from "./view";
import {bindActionCreators} from "redux";
import {viewActivity} from "../../../../service/Activity/action";

const mapStateToProps = (state) => ({
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewActivity,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(V2ActivityView);
